import { skipToken, useQuery } from '@apollo/client/react';
import moment from 'moment-timezone/builds/moment-timezone-with-data-10-year-range';
import { STATUSES } from '@guuru/partner-common';
import GET_PARTNER from './queries/GetFetchCurrentPartner';

export default (partnerId?: string) => {
  const { loading, data: { partner } = {} } = useQuery(
    GET_PARTNER,
    partnerId ? { variables: { id: partnerId } } : skipToken,
  );

  return {
    loading,
    partner: {
      ...partner,
      id: partnerId,
      timezone: partner?.timezone || moment.tz.guess(),
      logoUrl: partner?.settings?.appearance?.chatWidgetPhotoUrl,
      isDemo: partner?.status === STATUSES.demo,
      isAgentsEnabled: partner?.settings?.agents?.isEnabled,
      isAutomationEnabled: partner?.hasPredictions,
      isMentionsEnabled: partner?.settings?.community?.mentionsEnabled,
      isChatsEnabled: partner?.settings?.community?.chatsEnabled,
      isEvaluationsEnabled: partner?.settings?.community?.evaluationsEnabled,
      isBotEnabled: partner?.automation?.settings?.isBotEnabled,
      isMonitoringEnabled: partner?.settings?.tasks?.isMonitoringEnabled,
      defaultLanguage:
        partner?.settings?.appearance?.chatWidgetDefaultLanguage ?? undefined,
      enabledLanguages: partner?.settings?.translations?.enabledLanguages,
    },
  };
};
